import { Component } from '@angular/core';

@Component({
  selector: 'unh-dropdown-list-item',
  styleUrls: ['./dropdown-list-item.component.scss'],
  template: `
      <ng-content></ng-content>
  `
})
export class DropdownListItemComponent {}
